// Re-export VERIFICATION_STATUS from the single source of truth
export { VERIFICATION_STATUS } from 'utils/apiResponseErrorHandler';

export const VERIFICATION_TEXT = {
  loadingTitle: 'Verifying...',
  loadingMessage: 'Please wait while we process your verification.',
  noTokenProvided: 'No verification token provided. Please check your link.',
  invalidToken: 'Invalid verification token. Please request a new link.',
  verificationFnMissing: 'Verification function not provided.',
  resendFnMissing: 'Resend function not provided.',
  resendSuccess:
    'A new verification link has been sent. Please check your inbox.',
  resendButtonLabel: 'Resend',
  verificationInfo:
    'Verification links expire after 24 hours for security reasons. Please request a new verification link.',
  successWelcomePrefix: 'Welcome,',
  successAccountActive: 'Your account is now active and ready to use.',
  successEmailPrefix: 'Email:',
};
